import { useEffect } from "react";
import {
  FaTruck,
  FaWarehouse,
  FaRoute,
  FaShippingFast,
  FaBoxes,
  FaMapMarkedAlt,
  FaBusAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const LogisticsCards = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      offset: 200,
    });
  }, []);
  return (
    <div className="max-w-[1140px] mx-auto p-4 pt-20">
      <div>
        <h1 className="text-3xl font-bold text-white">
          Our Logistics & <span className="text-gradient">Transport Services</span>
        </h1>
        <div
          data-aos="fade-right"
          className="web3-underline w-[70px] mt-3"
        ></div>
        <p className="text-gray-400 text-lg py-7">
          We offer a complete range of logistics and transport solutions so
          that your supply chain can run at full speed.
        </p>
      </div>
      <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 max-sm:place-items-center gap-5">
        <div className="max-w-sm p-6 glass-card">
          <div className="flex justify-center py-8">
            <FaTruck size={50} className="text-customRed" />
          </div>
          <h5 className="mb-2 text-[18px] font-bold text-white text-center">
            Fleet Management
          </h5>
          <p className="mb-3 font-normal text-gray-400 text-center text-md">
            Monitor and manage your entire fleet from a single dashboard. Track
            vehicle health, fuel usage, driver performance, and maintenance
            schedules in real time.
          </p>
        </div>
        <div className="max-w-sm p-6 glass-card">
          <div className="flex justify-center py-8">
            <FaRoute size={50} className="text-customRed" />
          </div>
          <h5 className="mb-2 text-[18px] font-bold text-white text-center">
            Route Optimization
          </h5>
          <p className="mb-3 font-normal text-gray-400 text-center text-md">
            Cut fuel costs and delivery times with intelligent route planning.
            Our algorithms account for traffic, delivery windows, and vehicle
            capacity to find the best path.
          </p>
        </div>
        <div className="max-w-sm p-6 glass-card">
          <div className="flex justify-center py-8">
            <FaMapMarkedAlt size={50} className="text-customRed" />
          </div>
          <h5 className="mb-2 text-[18px] font-bold text-white text-center">
            Real-Time Shipment Tracking
          </h5>
          <p className="mb-3 font-normal text-gray-400 text-center text-md">
            Give your customers full visibility with live GPS tracking,
            automated status notifications, and accurate estimated arrival
            times for every shipment.
          </p>
        </div>
      </div>
      <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 max-sm:place-items-center gap-5 my-5">
        <div className="max-w-sm p-6 glass-card">
          <div className="flex justify-center py-8">
            <FaWarehouse size={50} className="text-customRed" />
          </div>
          <h5 className="mb-2 text-[18px] font-bold text-white text-center">
            Warehouse Management
          </h5>
          <p className="mb-3 font-normal text-gray-400 text-center text-md">
            Streamline inventory, picking, packing, and dispatch with warehouse
            management systems built to reduce errors and speed up
            fulfillment.
          </p>
        </div>
        <div className="max-w-sm p-6 glass-card">
          <div className="flex justify-center py-8">
            <FaShippingFast size={50} className="text-customRed" />
          </div>
          <h5 className="mb-2 text-[18px] font-bold text-white text-center">
            Last-Mile Delivery
          </h5>
          <p className="mb-3 font-normal text-gray-400 text-center text-md">
            Deliver a great final-mile experience with driver apps, proof of
            delivery, dynamic dispatching, and customer notifications that
            build loyalty.
          </p>
        </div>
        <div className="max-w-sm p-6 glass-card">
          <div className="flex justify-center py-8">
            <FaBoxes size={50} className="text-customRed" />
          </div>
          <h5 className="mb-2 text-[18px] font-bold text-white text-center">
            Supply Chain Analytics
          </h5>
          <p className="mb-3 font-normal text-gray-400 text-center text-md">
            Turn your logistics data into actionable insights. Forecast demand,
            identify bottlenecks, and optimize capacity with powerful analytics
            dashboards.
          </p>
        </div>
        <div className="max-w-sm p-6 glass-card">
          <div className="flex justify-center py-8">
            <FaBusAlt size={50} className="text-customRed" />
          </div>
          <h5 className="mb-2 text-[18px] font-bold text-white text-center">
            University & Educational Transport
          </h5>
          <p className="mb-3 font-normal text-gray-400 text-center text-md">
            Dedicated fleet services for universities and educational
            institutes, including daily pick-and-drop routes from various
            cities, study tours, and trips with safe, reliable, and punctual
            transport.
          </p>
        </div>
      </div>
      {/* IMAGE CONTENT START */}
      <div className="my-16 overlay-bg py-14 p-8">
        <div className="grid lg:grid-cols-2 md:grid-cols-2 max-sm:place-items-center gap-10">
          <div>
            <h1 data-aos="fade-up" className="text-white text-3xl font-bold">
              Move your business forward with smarter logistics
            </h1>
          </div>
          <div className="flex justify-end items-center">
            <Link to="/contactUs">
              <button
                type="button"
                className="text-white bg-customRed cursor-pointer focus:outline-none font-bold rounded-md text-sm px-7 py-3 text-center hover:scale-110 transition ease-in-out"
              >
                Talk to Our Experts
              </button>
            </Link>
          </div>
        </div>
      </div>
      {/* IMAGE CONTENT END */}
    </div>
  );
};

export default LogisticsCards;
